import { Component, HostListener, Inject, Input, OnChanges, OnInit } from '@angular/core';
import { environment } from '../../../environments/environment';

import { SharedModule } from '../../_shared/shared.module';

import { AbilityDirective } from '../../_shared/directives/ability.directive';

import { SessionService } from '../../_shared/services/session.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  standalone: true,
  imports: [SharedModule, AbilityDirective],
})
export class SidebarComponent implements OnInit, OnChanges {
  @Input() currentUser;
  @Input() currentMenu: string;

  atvCrEnabled = false;
  showCrm = false;

  constructor(
    private sessionService: SessionService,
    @Inject('$location') private $location: any
  ) {}

  ngOnInit() {
    if (!this.currentUser.sd) {
      this.atvCrEnabled = this.sessionService.getSelectedAccountCompany()['atv_cr_enabled'];
    }

    if (environment.name !== 'production') {
      this.showCrm = true;
    }
  }

  ngOnChanges() {
    // If user refresh the page
    // Only for angular components, not working as If refresh the page, it redirects to /
    /*  this.closeAllSubMenus(false);

    setTimeout(() => {
      // hack
      if (document.getElementById(this.currentMenu)) {
        document.getElementById(this.currentMenu).classList.add('open');

        if (document.querySelector('#' + this.currentMenu + ' .sub-menu')) {
          document.querySelector('#' + this.currentMenu + ' .sub-menu').classList.add('active');

          document.getElementById(this.currentMenu).querySelector('a').classList.add('active');
        }
      }
    }, 100); */
  }

  // click inside component
  // window:click in window
  // Close submenu when clicked outside and minifed
  @HostListener('window:click', ['$event']) onClick(event) {
    // console.log(event);
    let container = document.getElementById('container');

    if (!container) return;

    if (container.classList.contains('sidebar-closed')) {
      // console.log(event.target);
      let element = event.target as HTMLElement;

      let id = element.id || '';

      if (id === 'header' || id === 'sidebar' || id === 'content') {
        this.closeAllSubMenus(true);
      }
    }
  }

  openSubMenu(event) {
    let element = event.currentTarget;
    let subMenu = element.nextElementSibling;

    // For items without menu
    if (!subMenu || (subMenu && !subMenu.classList.contains('sub-menu'))) {
      this.closeAllSubMenus(false);
      element.parentElement.classList.add('open');
      return;
    }

    if (!subMenu.classList.contains('active')) {
      this.closeAllSubMenus(false);

      element.parentElement.classList.add('open');

      element.classList.add('active');

      subMenu.classList.add('active');
      subMenu.style.height = 'auto';

      let height = subMenu.clientHeight + 'px';

      subMenu.style.height = '0px';

      setTimeout(function () {
        subMenu.style.height = height;
      }, 0);
    } else {
      element.parentElement.classList.remove('open');

      element.classList.remove('active');

      subMenu.style.height = '0px';

      setTimeout(function () {
        subMenu.classList.remove('active');
      }, 200);
    }
  }

  openSubMenuLink() {
    let container = document.getElementById('container');

    if (container.classList.contains('sidebar-closed')) {
      this.closeAllSubMenus(true);
    }
  }

  addBooking() {
    this.$location.path('/bookings/new');
  }

  private closeAllSubMenus(keepCurrentClass) {
    let list = document.querySelectorAll('#nav > li');

    for (let i = 0; i < list.length; i++) {
      if (!keepCurrentClass) {
        list[i].classList.remove('open');
      }

      let subMenu = list[i].querySelector<HTMLElement>('.sub-menu');
      if (subMenu && subMenu.classList.contains('active')) {
        subMenu.classList.remove('active');
        subMenu.style.height = '0px';

        list[i].querySelector('a').classList.remove('active');
      }
    }
  }
}

// if (!this.sessionService.isLoggedIn()) return; // not needed
